<template>
  <div class="dashboardTenantsSummary">
    <ReportsDashboardMetric
      class="current"
      :value="getDashboardTenantsTotals.current"
      legend="per idag"
      color="secondary"
    />

    <h5 class="text-center mt-3">Startes</h5>
    <div class="dashboardTenantsSummary__grid">
      <ReportsDashboardMetric
        class="count"
        :value="getDashboardTenantsTotals.commencing.next30days"
        legend="neste 30 dager"
        :color="getDashboardTenantsTotals.commencing.next30days > 0 ? 'green' : 'secondary'"
        :prefix="getDashboardTenantsTotals.commencing.next30days > 0 ? '+' : ''"
        small
      />
      <ReportsDashboardMetric
        class="count"
        :value="getDashboardTenantsTotals.commencing.next60days"
        legend="neste 31-60 dager"
        :color="getDashboardTenantsTotals.commencing.next60days > 0 ? 'green' : 'secondary'"
        :prefix="getDashboardTenantsTotals.commencing.next60days > 0 ? '+' : ''"
        small
      />
      <ReportsDashboardMetric
        class="count"
        :value="getDashboardTenantsTotals.commencing.next90days"
        legend="neste 61-90 dager"
        :color="getDashboardTenantsTotals.commencing.next90days > 0 ? 'green' : 'secondary'"
        :prefix="getDashboardTenantsTotals.commencing.next90days > 0 ? '+' : ''"
        small
      />
    </div>

    <h5 class="text-center mt-2">Avsluttes</h5>
    <div class="dashboardTenantsSummary__grid">
      <ReportsDashboardMetric
        class="count"
        :value="getDashboardTenantsTotals.expiring.next30days"
        legend="neste 30 dager"
        :color="getDashboardTenantsTotals.expiring.next30days > 0 ? 'red' : 'secondary'"
        :prefix="getDashboardTenantsTotals.expiring.next30days > 0 ? '-' : ''"
        small
      />
      <ReportsDashboardMetric
        class="count"
        :value="getDashboardTenantsTotals.expiring.next60days"
        legend="neste 31-60 dager"
        :color="getDashboardTenantsTotals.expiring.next60days > 0 ? 'red' : 'secondary'"
        :prefix="getDashboardTenantsTotals.expiring.next60days > 0 ? '-' : ''"
        small
      />
      <ReportsDashboardMetric
        class="count"
        :value="getDashboardTenantsTotals.expiring.next90days"
        legend="neste 61-90 dager"
        :color="getDashboardTenantsTotals.expiring.next90days > 0 ? 'red' : 'secondary'"
        :prefix="getDashboardTenantsTotals.expiring.next90days > 0 ? '-' : ''"
        small
      />
    </div>
    <div class="d-flex justify-content-center mt-2">
      <button class="btn btn-sm btn-outline-secondary" @click="goToOverviewTenancy">Til rapport</button>
    </div>
  </div>
</template>

<script>
import ReportsDashboardMetric from '@/components/reports/dashboard/ReportsDashboardMetric';
import { mapGetters } from 'vuex';

export default {
  name: 'DashboardTenantsSummary',
  components: {
    ReportsDashboardMetric,
  },
  computed: {
    ...mapGetters('reports', ['getDashboardTenantsTotals']),
  },
  methods: {
    goToOverviewTenancy() {
      this.$router.push({
        name: 'reports_overview_tenancy',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dashboardTenantsSummary__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 2rem 1rem;
}
</style>
